<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" v-if="ValidarAcceso('grafica.show-distritos-federales')">
        <v-card width="auto" tile>
          <v-card-text>
            <fusioncharts v-if="showGraf"
              type="column2d"
              :width="width"
              :height="height"
              dataFormat="json"
              :dataSource="dataMain">
                  FusionCharts will render here...
            </fusioncharts>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: (vm) => ({
    showGraf: false,
    width: '100%',
    height: '400',
    type: 'mscolumn2d',
    dataFormat: 'json',
    dataMain: null,
    pieDataSource: {
      chart: {
        caption: 'App Publishing Trend',
        subcaption: '2012-2016',
        xaxisname: 'Years',
        yaxisname: 'Total number of apps in store',
        formatnumberscale: '1',
        plottooltext: '<b>$dataValue</b> apps were available on <b>$seriesName</b> in $label',
        theme: 'fusion',
        drawcrossline: '1'
        // caption: 'Para Graficas con preguntas',
        // theme: 'fint'
      },
      categories: [
        {
          category: [
            {
              label: '2012'
            },
            {
              label: '2013'
            },
            {
              label: '2014'
            },
            {
              label: '2015'
            },
            {
              label: '2016'
            }
          ]
        }
      ],
      dataset: [
        {
          seriesname: 'iOS App Store',
          data: [
            {
              value: '125000'
            },
            {
              value: '300000'
            },
            {
              value: '480000'
            },
            {
              value: '800000'
            },
            {
              value: '1100000'
            }
          ]
        },
        {
          seriesname: 'Google Play Store',
          data: [
            {
              value: '70000'
            },
            {
              value: '150000'
            },
            {
              value: '350000'
            },
            {
              value: '600000'
            },
            {
              value: '1400000'
            }
          ]
        },
        {
          seriesname: 'Amazon AppStore',
          data: [
            {
              value: '10000'
            },
            {
              value: '100000'
            },
            {
              value: '300000'
            },
            {
              value: '600000'
            },
            {
              value: '900000'
            }
          ]
        }
      ]
    },
    permisos: {},
    permisos2: null
  }),
  components: {
  },
  mounted () {
    if (this.ValidarAcceso('grafica.show-distritos-federales')) this.getUrl('grafica.show-distritos-federales')
  },
  methods: {
    ...mapActions(['getUrlServices', 'getUrlServicesSecoundAction']),
    ...mapMutations([]),
    ValidarAcceso (permiso) {
      return this.ReadOnlyPermiso(JSON.parse(localStorage.getItem('permisos')), permiso)
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServicesSecoundAction(router)
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectSecound'])
  },
  watch: {
    get_urls () { this.getUrl('encuesta.grafica.show') },
    get_objectSecound (val) {
      this.dataMain = val
      setTimeout(() => { this.showGraf = true }, 500)
    }
  }
}
</script>
